<template>
    <section content padding v-if="features">
        <Row class="plr-lg">
            <Col :xs="24" :sm="24" :md="10" :lg="10" v-if="features.left">
                <div class="d-block" style="position: -webkit-sticky; position: sticky; top: 100px;">
                    <div class="d-block" v-for="(item, index) in features.left" :key="index">
                        <div class="photo-view rectangle" v-if="false">
                            <img :preview="new Date().getTime()" :src="item.cover"/>
                        </div>
                        <h1 class="c-primary">{{ item.title }}</h1>
                        <br/>
                        <div data-box="article" class="d-block" v-html="item.content"/>
                    </div>
                </div>
            </Col>
            <Col :xs="24" :sm="24" :md="2" :lg="2">&nbsp;</Col>
            <Col :xs="24" :sm="24" :md="12" :lg="12" features.right>
                <div class="d-block" v-for="(item, index) in features.right" :key="index">
                    <div class="photo-view rectangle">
                        <img :preview="new Date().getTime()" :src="item.cover"/>
                    </div>
                    <br/>
                    <h1>{{ item.title }}</h1>
                    <h2>{{ item.desc }}</h2>
                    <div class="d-block" v-html="item.content"/>
                    <br/>
                    <br/>
                </div>
            </Col>
        </Row>
    </section>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                features: null,
            }
        },
        async beforeDestroy() {
            await this.$bus.off('initFeatures');
        },
        async mounted() {
            this.$bus.on('initFeatures', async (data, com) => {
                if (!data || !com) return;
                await this.getFeatures();
            });
        },
        methods: {
            async getFeatures(){
                debugger
                let res = await this.$api.getHttp('/product/features?id=' + this.$route.query.id + '&lang=' + this.$common.config.lang);
                console.log('this.getSummary---------->', res);
                let data = res.data.data;
                if (!data || data.length === 0){
                    return this.features = null;
                }
                let leftData = [], rightData = [];
                data.forEach(item => {
                    if (item.left){
                        leftData.push(item);
                    } else {
                        rightData.push(item);
                    }
                });
                this.features = {} = {
                    left: leftData,
                    right: rightData,
                };
                console.log('this.getFeatures---------->', this.features);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Features.vue